import {CSession,ConectParms,ApiResponseData,RequestPram} from "./securesession/client";
import {reConnectParamerter,keyUpdateParamerter} from "./securesession/keyEx";
import * as resType from "./api_response_type";

export class apiRequest{
    private CSession:CSession;
    
    constructor(parms:ConectParms){
        this.CSession = new CSession(parms);
    }
    public async connect(option?:{ reConnect?: reConnectParamerter,keyUpdate?: keyUpdateParamerter}){
        return await this.CSession.conect(option);
    }
    public getSessionData() {
        return this.CSession.getSessionData();
    }
    public async clearSession(){
        return await this.CSession.conect();
    }

    public request = {
        session:async ()=>{
            return await this.CSession.request({
                "method":"GET",
                "path":"/api/v1/session",
            }) as ApiResponseData & {data:resType.sessionData};
        },
        desSession:async ()=>{
            return await this.CSession.request({
                "method":"DELETE",
                "path":"/api/v1/session",
                "wOTT":true,
            }) as ApiResponseData & {data:boolean};
        },
        auth:async (pram:resType.API_auth_req)=>{
            return await this.CSession.request({
                "method":"POST",
                "path":"/api/v1/auth/user",
                "body":pram,
            }) as ApiResponseData & {data:resType.apiResponseData_auth};
        },
        addressConf:async (code:string,pram?:{proxyApprval?:boolean,lineActivate?:boolean}) => {
            return await this.CSession.request({
                "path":"/api/v1/addressconf",
                "method":"GET",
                "params":{
                    "code":code,
                    "proxyApprval":typeof pram?.proxyApprval!=="undefined"?pram.proxyApprval:undefined,
                    "lchk":typeof pram?.lineActivate!=="undefined"?pram.lineActivate:undefined,
                },
                "passThrough":true,
            }) as ApiResponseData & {data:{flag?:boolean,activated?:boolean,name?:string}};
        },
        getEvents:async () => {
            return await this.CSession.request({
                "path":"/api/v1/events",
                "method":"GET",
            }) as ApiResponseData & {data:resType.ResEcEvents};
        },
        getEcReportsList:async (eventId:string) => {
            return await this.CSession.request({
                "path":`/api/v1/event/${encodeURIComponent(eventId)}/report`,
                "method":"GET",
            }) as ApiResponseData & {data:resType.EcReportResponse};
        },
        getEcReport:async (reportId:string) => {
            return await this.CSession.request({
                "path":`/api/v1/report/${encodeURIComponent(reportId)}`,
                "method":"GET",
                "passThrough":true,
            }) as ApiResponseData & {data:resType.EcReportResponse};
        },
        postEcReport:async (reportId:string,reportData:Array<resType.ReportQuColumn>,au?:string) => {
            return await this.CSession.request({
                "path":`/api/v1/report/${encodeURIComponent(reportId)}`,
                "method":"POST",
                "params":au?{"au":au}:undefined,
                "body":reportData,
                "passThrough":true,
            }) as ApiResponseData & {data:boolean};
        },
        postEcMemo:async (eventId:string,reportId:string,memo:string) => {
            return await this.CSession.request({
                "path":`/api/v1/reportmemo/${encodeURIComponent(eventId)}/${encodeURIComponent(reportId)}`,
                "method":"POST",
                "body":{"memo":memo}
            }) as ApiResponseData & {data:boolean};
        },
        getEcChat:async (eventId:string,seqNo?:number) => {
            return await this.CSession.request({
                "path":`/api/v1/event/${encodeURIComponent(eventId)}/chat`,
                "method":"GET",
                "params":seqNo?{"seq":seqNo}:undefined,
            }) as ApiResponseData & {data:Array<resType.EcChat>};
        },
        postEcChat:async (eventId:string,text:string) => {
            return await this.CSession.request({
                "path":`/api/v1/event/${encodeURIComponent(eventId)}/chat`,
                "method":"POST",
                "body":{chat:text}
            }) as ApiResponseData & {data:boolean};
        },
        my:{
            changePassword:async (pram:{currentPassword:string,password:string,otpCode?:string}) => {
                const reqPra:resType.API_passwordChange_Req = {
                    "current":pram.currentPassword,
                    "password":pram.password,
                }
                if(pram.otpCode){
                    reqPra.otpToken = pram.otpCode;
                }
                return await this.CSession.request({
                    "method":"PUT",
                    "path":"/api/v1/my/password",
                    "body":reqPra,
                }) as ApiResponseData & {data:resType.API_passwordChange_Res};
            },
            userInfo:async () => {
                return await this.CSession.request({
                    "path":"/api/v1/my/userinfo",
                    "method":"GET",
                }) as ApiResponseData & {data:resType.apiResponseData_userFull};
            },
            addAddress:async(addressData:resType.PostAddressData) => {
                return await this.CSession.request({
                    "method":"POST",
                    "path":"/api/v1/my/adress",
                    "body":addressData,
                }) as ApiResponseData & {data:boolean|string};
            },
            removeAddress:async(addressNo:number) => {
                return await this.CSession.request({
                    "method":"DELETE",
                    "path":`/api/v1/my/adress/${addressNo.toString()}`,
                    "wOTT":true,
                }) as ApiResponseData & {data:boolean};
            },
            totp:{
                newSecret:async(password:string) => {
                    return await this.CSession.request({
                        "method":"PUT",
                        "path":`/api/v1/my/totp/new`,
                        "body":{password}
                    }) as ApiResponseData & {data:resType.SalaAPI_TOTP_NewSecret_res};
                },
                activateSecret:async(otpToken:string) => {
                    return await this.CSession.request({
                        "method":"PUT",
                        "path":`/api/v1/my/totp/activate`,
                        "body":{otpToken}
                    }) as ApiResponseData & {data:boolean};
                },
                clearSecret:async(password:string,otpToken:string) => {
                    return await this.CSession.request({
                        "method":"PUT",
                        "path":`/api/v1/my/totp/clear`,
                        "body":{password,otpToken}
                    }) as ApiResponseData & {data:boolean};
                },
            },
        },
        admin:{
            getUserList:async () => {
                return await this.CSession.request({
                    "path":"/api/v1/admin/users",
                    "method":"GET",
                }) as ApiResponseData & {data:resType.apiResponseData_ecusers};
            },
            getEcConfig:async () => {
                return await this.CSession.request({
                    "path":"/api/v1/admin/ecconfig",
                    "method":"GET",
                }) as ApiResponseData & {data:resType.admin_getEcConfig};
            },
            putEcConfig:async (configName:string,val:any) => {
                return await this.CSession.request({
                    "path":`/api/v1/admin/ecconfig/${encodeURIComponent(configName)}`,
                    "method":"PUT",
                    "body":val
                }) as ApiResponseData & {data:boolean};
            },
            putEcAlert:async (type:number,val:Array<resType.EcAlertConfig>) => {
                return await this.CSession.request({
                    "path":`/api/v1/admin/ecalert/${type.toString()}`,
                    "method":"PUT",
                    "body":val
                }) as ApiResponseData & {data:boolean};
            },
            setEcAdminUser:async (userId:string) => {
                return await this.CSession.request({
                    "path":`/api/v1/admin/adminuser`,
                    "method":"POST",
                    "body":{"userid":userId}
                }) as ApiResponseData & {data:boolean};
            },
            unsetEcAdminUser:async (userId:string) => {
                return await this.CSession.request({
                    "path":`/api/v1/admin/adminuser/${userId}`,
                    "method":"DELETE",
                    "wOTT":true,
                }) as ApiResponseData & {data:boolean};
            },
            getAllowViewUsers:async (userId:string,ex?:resType.exView) => {
                if(ex){
                    return await this.CSession.request({
                        "path":`/api/v1/admin/viewusers/${userId}`,
                        "method":"POST",
                        "body":ex,
                    }) as ApiResponseData & {data:resType.EcViewList};
                }else{
                    return await this.CSession.request({
                        "path":`/api/v1/admin/viewusers/${userId}`,
                        "method":"GET",
                    }) as ApiResponseData & {data:resType.EcViewList};
                }
            },
            updateAllowViewUsers:async (userId:string,ex:resType.exView) => {
                return await this.CSession.request({
                    "path":`/api/v1/admin/viewusers/${userId}/update`,
                    "method":"POST",
                    "body":ex,
                }) as ApiResponseData & {data:boolean};
            },
            getAllListOfAllowViewUsers:async () => {
                return await this.CSession.request({
                    "path":`/api/v1/admin/viewusers_all`,
                    "method":"GET",
                }) as ApiResponseData & {data:Array<{user:string,ulist:resType.EcViewList}>};
            },
            getManualEventKey:async () => {
                return await this.CSession.request({
                    "path":`/api/v1/admin/event/manual_req_key`,
                    "method":"GET",
                }) as ApiResponseData & {data:{key:string}};
            },
            reqManualEvent:async (detail:resType.EventRequestDetal) => {
                return await this.CSession.request({
                    "path":`/api/v1/admin/event/manual_req`,
                    "method":"POST",
                    "body":detail
                }) as ApiResponseData & {data:{key:string}};
            },
            finishEvent:async (eventId:string) => {
                return await this.CSession.request({
                    "path":`/api/v1/admin/event/finish`,
                    "method":"PUT",
                    "body":{eventId}
                }) as ApiResponseData & {data:boolean};
            },
            sendMessege:async (messege:string) => {
                return await this.CSession.request({
                    "path":"/api/admin/messege",
                    "method":"POST",
                    "body":{"mes":messege}
                }) as ApiResponseData & {data:boolean};
            },
            getMesTepmlete:async()=>{
                return await this.CSession.request({
                    "method":"GET",
                    "path":`/api/v1/ecdata/admin/messegetemplete/`,
                }) as ApiResponseData & {data:Array<resType.MessegeTemplete> };
            },
            putMesTepmlete:async(pram:resType.MessegeTemplete)=>{
                return await this.CSession.request({
                    "method":"PUT",
                    "path":`/api/v1/ecdata/admin/messegetemplete/${pram.id.toString()}`,
                    "body":pram
                }) as ApiResponseData & {data:boolean };
            },
        },
    }
}
